<a
	mat-flat-button
	*ngIf="(tokenRewardCount$ | async) !== 0 && !!(tokenRewardCount$ | async)"
	href="{{ url$ | async }}"
	class="ticket-counter-button"
	test-id="ticket-counter-button"
	matTooltip="{{ 'secondary-menu.common.ticket-counter' | translate }}"
	matTooltipClass="obg-m-navigation-tooltip"
>
	<span class="ticket-counter-title">{{ "user-summary.ticket-counter-title" | translate }}</span>
	<span class="ticket-counter-icon ico-ticket"></span>
	<span class="ticket-counter-count" obgSensitiveData>{{ tokenRewardCount$ | async }}</span>
</a>
